export enum StockTypes {
  dealer = 'dealer',
  distribution = 'distribution',
}
